<template>
  <div
    class="boss-message-box boss-message-box-received"
    :class="{'boss-message-box-can-send':canSendMessage}"
  >
    <img
      src="@/assets/images/boss-avatar.svg"
      class="boss-message-box-avatar boss-message-box-avatar-user"
    >
    <applicant-message-history-message-detail
      :body="body"
      :date="date"
      :subject="subject"
    />
    <div
      v-if="canSendMessage"
      class="boss-message-last-button-block"
    >
      <button
        v-tooltip="tooltip"
        class="boss-button pega-button"
        type="button"
        data-test="quote-message"
        :disabled="isReserved || isWithdraw"
        @click="setMessage"
      >
        メッセージを引用してメールを作成
      </button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import ApplicantMessageHistoryMessageDetail from '@/components/molecules/ApplicantMessageHistoryMessageDetail.vue'

export default {
  components: {
    ApplicantMessageHistoryMessageDetail
  },
  props: {
    body: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    subject: {
      type: String,
      default: ''
    },
    isReserved: {
      type: Boolean,
      default: false
    },
    isWithdraw: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'canSendMessage'
    ]),
    tooltip () {
      return this.isReserved ? { content: 'メッセージ予約中のためメールを作成できません。' } : undefined
    }
  },
  methods: {
    setMessage () {
      if (this.isReserved || this.isWithdraw) return // 予約中または退会している場合は処理skip
      this.$emit('setMessage', {
        message: {
          body: '>' + _.replace(this.replaceShiftJisCode(this.body), /\r?\n/g, '\n>'),
          subject: this.replaceShiftJisCode(this.subject)
        }
      })
    },
    replaceShiftJisCode (val) {
      // DBに文字コードで登録されている「〜」を変換する必要があったためやむを得ず変換処理を入れる
      return _.replace(val, /&#12316;/g, '〜')
    }
  }
}
</script>
